import DOMPurify from "dompurify";

const CONFIG = {
  ALLOWED_TAGS: ["p", "br", "strong", "b", "em", "i", "u", "ul", "ol", "li", "h2", "h3", "h4", "a"],
  ALLOWED_ATTR: ["href", "target", "rel"],
};

// Renders rich-text HTML coming from ProPract descriptions / CMS fields.
// Sanitized with a strict allowlist before injection.
export const stripHtml = (s) => {
  if (!s) return "";
  const doc = new DOMParser().parseFromString(String(s), "text/html");
  return (doc.body.textContent || "").replace(/\s+/g, " ").trim();
};
export const RichText = ({ html, className = "", ...rest }) => {
  if (!html) return null;
  const clean = DOMPurify.sanitize(String(html), CONFIG);
  return (
    <div
      className={`whitespace-pre-line ${className}`}
      dangerouslySetInnerHTML={{ __html: clean }}
      {...rest}
    />
  );
};
